export default function createEnum(values) {
    const array = [];
    const enumObj = {};
    for (const v of values) {
        const obj = {
            name: v.name,
            type: v.type
        };
        Object.freeze(obj);
        array.push(obj);

        if (v.enum) {
            enumObj[v.enum] = v.type;
        }
    }
    Object.freeze(array);
    Object.freeze(enumObj);

    return [array, enumObj];
}
